<template>
    <div class="table-list organization-group-list">
        <member-list :obj="selectedObj"></member-list>
        <modal class="del-group" :display="modalState.delGroupModal" @modalStatus="closeModal('delGroupModal')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除業務分群</h1>
            <div class="content">
                確定要刪除“{{delGroup.groupName}}”分群嗎？確定後將直接刪除此業務分群
            </div>
            <div class="btn-group">
                <button class="default-button" @click="delOrganizationGroup()">確認</button>
                <button class="border-button" @click="closeModal('delGroupModal')">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="group-name">分群名稱</span>
            <span class="member">成員</span>
            <span class="note">備註</span>
            <span class="create-date">建立時間</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && organizationGroupList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="organizationGroupList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="group-name">{{list.groupName}}</span>
                    <span class="member" @click="openMemberList(list)">{{getMemberShowText(list.memberAmount)}}</span>
                    <span class="note">{{list.note}}</span>
                    <span class="create-date">{{getFormatDateTime(list.createdDate)}}</span>
                    <span class="action" v-if="bizAuth.editGroup.hasRight || bizAuth.deleteGroup.hasRight">
                        <dot-drop-menu>
                            <ul>
                                <router-link v-if="bizAuth.editGroup.hasRight" :to="{ name: 'bizEditOrganizationGroup', query: {'id': list.id} }">
                                    <li>編輯業務分群</li>
                                </router-link>
                                <li v-if="bizAuth.deleteGroup.hasRight" @click="delGroup.groupId = list.id, delGroup.groupName = list.groupName, openModal(list)">刪除業務分群</li>
                            </ul>
                        </dot-drop-menu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import memberList from '@/components/bussiness/widges/modals/memberList.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            modalState: {
                delGroupModal: false
            },
            delGroup: {
                groupId: null,
                groupName: null,
            },
            selectedObj: null,
            isLoading: true
        }
    },
    props: {
        
    },
    watch: {
        
    },
    mounted () {
        this.getOrganizationGroupList()
    },
    methods: {
        openMemberList: function (list) {
            this.selectedObj = list
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizMemberList'})
        },
        getOrganizationGroupList: function () {
            this.$store.dispatch('getBizOrganizationGroupList')
            .then(()=>{
                this.isLoading = false
            })
        },
        setFilterDefault: function () {
        
        },
        getMemberShowText: function(rawText) {
            if(rawText == undefined){
                rawText = 0
            }
            return rawText + " 位"
        },
        // 刪除業務分群
        delOrganizationGroup: function () {
            this.$analyticsBiz.logEvent('刪除業務分群', { screen_name: '業務分群列表'})
            this.$store.dispatch('delBizOrganizationGroup', this.delGroup.groupId)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.modalState.delGroupModal = false
                    this.getOrganizationGroupList()
                    if(res.data.errorMsg){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                console.log(err)
            })
        },
        openModal: function (item) {
            if(item.wholeCompanyGroup){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '不能刪除全區業務',type: 'error', closeBtn: true})
            }else if(item.memberAmount){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '分群下有業務員不能刪除',type: 'error', closeBtn: true})

            }else{
                this.modalState.delGroupModal = true
            }
        },
        // 關閉角色modal
        closeModal: function () {
            this.modalState.delGroupModal = false
        },
    },
    computed: {
        filterByWord: function () {
            return this.organizationGroupList.filter((item) => {
                if( this.filterWord ){
                    if( item.groupName.includes(this.filterWord) || item.memberAmount.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            organizationGroupList: 'GET_BIZ_ORGANIZATION_GROUP_LIST',
            filterWord: 'GET_BIZ_ORGANIZATION_FILTER_WORD',
            bizAuth: 'GET_BIZ_AUTH',

        })
    },
    components: {
        DotDropMenu,
        Modal,
        memberList,
        tableLoading
    }
}
</script>
<style lang="scss">
    .table-list.organization-group-list{
        margin-bottom: 150px;
        .table-list-title .group-name,
        .table-list-body ul li .group-name{
            width: 100px;
            margin-right: 60px;
        }
        .table-list-title .member,
        .table-list-body ul li .member{
            width: 150px;
            margin-right: 16px;
        }
        .table-list-body ul li .member{
            color: #ff9275;
            cursor: pointer;
        }
        .table-list-title .note,
        .table-list-body ul li .note{
            width: 490px;
            margin-right: 30px;
        }
        .table-list-title .create-date,
        .table-list-body ul li .create-date{
            width: 72px;
            margin-right: 130px;
        }
        .table-list-title .action,
        .table-list-body ul li .action{
            width: 28px;
        }

        #modal.del-group{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    // @media screen and (max-width: 1280px){
    //     .biz-table-list.organization-group-list{
    //         .table-list-title .group-name,
    //         .table-list-body ul li .group-name{
    //             width: 100px;
    //             margin-right: 60px;
    //         }
    //         .table-list-title .member,
    //         .table-list-body ul li .member{
    //             width: 130px;
    //             margin-right: 16px;
    //         }
    //         .table-list-title .note,
    //         .table-list-body ul li .note{
    //             width: 430px;
    //             margin-right: 45px;
    //         }
    //         .table-list-title .create-date,
    //         .table-list-body ul li .create-date{
    //             width: 72px;
    //             margin-right: 113px;
    //         }
    //         .table-list-title .action,
    //         .table-list-body ul li .action{
    //             width: 24px;
    //         }
    //     }
    
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/organizationGroup/organizationGroupList.vue